const type = 'TOGGLE_STATEMENT_VIEW';

const toggleStatementView = () => ({
  type,
});

export { type };
export default toggleStatementView;
